/**
 * Translates contest area to contest name
 *
 * @flow
 */
import blue from "@material-ui/core/colors/blue";
import orange from "@material-ui/core/colors/orange";

export const CONTEST_AREA_AF = {
  ARAB: {
    name: "Arab Collegiate Programming Contest",
    color: blue[500],
    colorHovered: blue[700],
    abbr: "acpc",
  },
  SOUTH_AFRICA: {
    name: "South Africa",
    color: orange[500],
    colorHovered: orange[700],
    abbr: "south-africa",
  },
};

export type ICPCContest = {
  abbr: string,
  name: string,
  color: string,
  colorHovered: string,
};

const nameToContestArea = {
  "South Africa": CONTEST_AREA_AF.SOUTH_AFRICA,
  Madagascar: CONTEST_AREA_AF.SOUTH_AFRICA,
  Namibia: CONTEST_AREA_AF.SOUTH_AFRICA,
  Botswana: CONTEST_AREA_AF.SOUTH_AFRICA,
  Zimbabwe: CONTEST_AREA_AF.SOUTH_AFRICA,
  Mozambique: CONTEST_AREA_AF.SOUTH_AFRICA,
  Angola: CONTEST_AREA_AF.SOUTH_AFRICA,
  Zambia: CONTEST_AREA_AF.SOUTH_AFRICA,
  Malawi: CONTEST_AREA_AF.SOUTH_AFRICA,
  Tanzania: CONTEST_AREA_AF.SOUTH_AFRICA,
  "Democratic Republic of the Congo": CONTEST_AREA_AF.SOUTH_AFRICA,
  Uganda: CONTEST_AREA_AF.SOUTH_AFRICA,
  Burundi: CONTEST_AREA_AF.SOUTH_AFRICA,
  Rwanda: CONTEST_AREA_AF.SOUTH_AFRICA,
  Kenya: CONTEST_AREA_AF.SOUTH_AFRICA,
  Somalia: CONTEST_AREA_AF.SOUTH_AFRICA,
  "Republic of Congo": CONTEST_AREA_AF.SOUTH_AFRICA,
  Gabon: CONTEST_AREA_AF.SOUTH_AFRICA,
  "Equatorial Guinea": CONTEST_AREA_AF.SOUTH_AFRICA,
  Lesotho: CONTEST_AREA_AF.SOUTH_AFRICA,
  Swaziland: CONTEST_AREA_AF.SOUTH_AFRICA,

  Puntland: CONTEST_AREA_AF.ARAB,
  Somaliland: CONTEST_AREA_AF.ARAB,
  Djibouti: CONTEST_AREA_AF.ARAB,
  Ethiopia: CONTEST_AREA_AF.ARAB,
  Eritrea: CONTEST_AREA_AF.ARAB,
  "South Sudan": CONTEST_AREA_AF.ARAB,
  "Central African Republic": CONTEST_AREA_AF.ARAB,
  Cameroon: CONTEST_AREA_AF.ARAB,
  Nigeria: CONTEST_AREA_AF.ARAB,
  Chad: CONTEST_AREA_AF.ARAB,
  Sudan: CONTEST_AREA_AF.ARAB,
  Benin: CONTEST_AREA_AF.ARAB,
  Togo: CONTEST_AREA_AF.ARAB,
  Ghana: CONTEST_AREA_AF.ARAB,
  "Ivory Coast": CONTEST_AREA_AF.ARAB,
  Liberia: CONTEST_AREA_AF.ARAB,
  "Sierra Leone": CONTEST_AREA_AF.ARAB,
  Guinea: CONTEST_AREA_AF.ARAB,
  Senegal: CONTEST_AREA_AF.ARAB,
  Gambia: CONTEST_AREA_AF.ARAB,
  Mauritania: CONTEST_AREA_AF.ARAB,
  Mali: CONTEST_AREA_AF.ARAB,
  Niger: CONTEST_AREA_AF.ARAB,
  Algeria: CONTEST_AREA_AF.ARAB,
  Tunisia: CONTEST_AREA_AF.ARAB,
  Libya: CONTEST_AREA_AF.ARAB,
  Egypt: CONTEST_AREA_AF.ARAB,

  Jordan: CONTEST_AREA_AF.ARAB,
  "Saudi Arabia": CONTEST_AREA_AF.ARAB,
  Yemen: CONTEST_AREA_AF.ARAB,
  Oman: CONTEST_AREA_AF.ARAB,
  "United Arab Emirates": CONTEST_AREA_AF.ARAB,
  Qatar: CONTEST_AREA_AF.ARAB,
  Kuwait: CONTEST_AREA_AF.ARAB,
  Iraq: CONTEST_AREA_AF.ARAB,
  Syria: CONTEST_AREA_AF.ARAB,
  "Iraqi Kurdistan": CONTEST_AREA_AF.ARAB,
  "West Bank": CONTEST_AREA_AF.ARAB,
  Lebanon: CONTEST_AREA_AF.ARAB,
  "Burkina Faso": CONTEST_AREA_AF.ARAB,
  Morocco: CONTEST_AREA_AF.ARAB,
  "Western Sahara": CONTEST_AREA_AF.ARAB,
  "Guinea Bissau": CONTEST_AREA_AF.ARAB,
  Spain: CONTEST_AREA_AF,
};

export function toICPCContest(geographyProperty: Object): ICPCContest {
  // custom countries
  // we are using objects/hash maps to be faster than switch/ifs since this is evaluated on every iteration
  return (
    nameToContestArea[geographyProperty.geounit] || {
      name: "",
      color: "#00000000",
      colorHovered: "#00000000",
      abbr: "undefined",
    }
  );
}
